import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component, ElementRef,
  EventEmitter,
  Input,
  Output,
  QueryList, Renderer2, ViewChild,
  ViewChildren,
  ViewEncapsulation
} from '@angular/core';
import {MessageService} from 'primeng/api';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {CcBaseComponent} from '../../cc-base.component';
import {FormFieldGroupConfig} from '../../../model/api/form-field-group-config';
import {FormFieldConfig} from '../../../model/api/form-field-config';
import {AutoComplete} from "primeng/autocomplete";
import {CcSubFormBaseComponent} from "./cc-sub-form-base.component";
import {Panel} from "primeng/panel";

@Component({
  selector: 'app-cc-form[formConfig]',
  templateUrl: './cc-form.component.html',
  styleUrls: ['./cc-form.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    TranslateService,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CcFormComponent<T = any> extends CcBaseComponent {

  FieldTypes = FormFieldConfig.TYPE;

  fieldEventMap = {};

  fieldValueMap = {};

  @Input()
  class: string = '';

  @Input()
  formConfig: FormFieldGroupConfig[];

  @Input()
  formRecord: any;
  @Output()
  formRecordChange = new EventEmitter<any>();

  @Input()
  submitted: boolean = false;

  @Input()
  transPartKey: String;

  @Input()
  loading: boolean = false;

  @Input()
  loadingProgressValue: number = 100;

  @Input()
  globalErrorMessage: string;

  @Input()
  globalInfoMessage: string;

  @ViewChildren('ccSubForm')
  subFormComponents: QueryList<CcSubFormBaseComponent>;

  @ViewChildren('pPanel')
  pPanels: QueryList<Panel>;

  @Output()
  sizeChanged = new EventEmitter<any>();

  constructor(public el: ElementRef, cdref: ChangeDetectorRef,
              messageService: MessageService,
              translateService: TranslateService, private renderer: Renderer2) {
    super(cdref, messageService, translateService);
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
    setTimeout(() => this.closePanel())
  }

  closePanel() {
    if (this.formConfig) {
      this.pPanels.forEach((pPanel, index) => {
        if (pPanel.collapsed ) {
          // @ts-ignore
          const childDiv = pPanel.el.nativeElement.querySelector('.p-toggleable-content.ng-trigger.ng-trigger-panelContent'); // adjust this if needed

          if (childDiv) {
            this.renderer.setAttribute(childDiv, 'aria-hidden', 'true');
            this.renderer.setStyle(childDiv, 'height', '0px');
          }
        }
      });
      if (this.subFormComponents)
        this.subFormComponents.forEach(ccForm => ccForm.reloadFieldValueMap());
    }
  }

  // tslint:disable-next-line:use-life-cycle-interface
  ngOnInit(): void {
    this.initConfigs();
    this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.initConfigs();
      this.reloadFieldValueMap();
    })
    this.reloadFieldValueMap();
    // this.formRecordChange.subscribe(value => {
    //   console.log("------> formRecordChange ")
    //   setTimeout(() => {
    //     for (let fieldEventMapKey in this.fieldEventMap) {
    //       this.fieldEventMap[fieldEventMapKey].emit(this.formRecord[fieldEventMapKey]);
    //       console.log("------> fieldEventMapKey "+fieldEventMapKey)
    //     }
    //   });
    // });
  }

  // tslint:disable-next-line:use-life-cycle-interface
  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  recordChanged() {
    this.reloadFieldValueMap();
    this.formRecordChange.emit(this.formRecord);
  }

  public reloadFieldValueMap(): void {
    // console.log("------> reloadFieldValueMap");
    // setTimeout(() => {
    if (this.formConfig && this.formRecord) {
      this.formConfig.forEach((groupConf, groupIndex) => {
        if (groupConf.hidden)
          this.fieldValueMap['hiddenGroup-' + groupIndex] = groupConf.hidden(this.formRecord);
        groupConf.fields.forEach((fieldConf, fieldIndex) => {
          if (fieldConf.hidden)
            this.fieldValueMap['hiddenField-' + groupIndex + '_' + fieldIndex] = fieldConf.hidden(this.formRecord);
        });
      });
      if (this.subFormComponents)
        this.subFormComponents.forEach(ccForm => ccForm.reloadFieldValueMap());
    }
    // -- fieldConfig.icon()
    // fieldConfig.icon(option.id)
    // formRecord[fieldConfig.field]?(fieldConfig.icon(formRecord[fieldConfig.field])):''
    // fieldConfig.iconValue()
    // fieldConfig.iconValue ? fieldConfig.iconValue(option.id) : ''
    // fieldConfig.iconValue ? fieldConfig.iconValue(formRecord[fieldConfig.field]) : ''
    // (fieldConfig.disabled?fieldConfig.disabled(formRecord):false)
    // fieldConfig.options()
    // fieldConfig.findOptionText ? fieldConfig.findOptionText(formRecord[fieldConfig.field])
    //  -- fieldGroup.hidden?fieldGroup.hidden(formRecord):false
    // fieldGroup.hidden?fieldGroup.hidden(formRecord):(fieldConfig.hidden?fieldConfig.hidden(formRecord):false)
    // });
    this.cdref.detectChanges();
  }
}
